import Resource_serversPage from './resource_serversPage';
export default Resource_serversPage;
